import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import packTraceService from '../services/packTrace.service'
import packTraceApi, { PackTraceData } from '../apis/packTrace.api'
import Card from '../components/Card'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import PageHeading from '../components/PageHeading'
import TableVertical, { TableVerticalHeader } from '../components/TableVertical'
import CardButton from '../components/CardButton'

interface PackTraceRouteState {
  id: number
}

interface PackTraceProps
  extends RouteComponentProps<any, any, PackTraceRouteState> {}

interface PackTraceState {
  packTrace: PackTraceData | null
}

class PackTrace extends Component<PackTraceProps, PackTraceState> {
  get headers (): TableVerticalHeader[] {
    const { packTrace } = this.state
    return packTraceService.tableVerticalHeaders(packTrace)
  }

  constructor (props: PackTraceProps) {
    super(props)
    this.state = {
      packTrace: null
    }
  }

  get id () {
    return this.props.location.state.id
  }

  readPackTrace () {
    packTraceApi.read(this.id, packTrace => {
      if (!packTrace) return
      this.setState({ packTrace })
    })
  }

  componentDidMount () {
    this.readPackTrace()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="half">
          <Card>
            <PageHeading
              text={i18n("View Pack Trace")}
              doc='pack-traces-view-pack-trace' />
            <TableVertical
              headers={this.headers}
              data={this.state.packTrace} />
            <CardButton cancelText={i18n("Back")} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(PackTrace)
